import { PROFILES } from "@/enum/Profiles";

import { userSettings, saveUserSettings } from "@/globals/userSettings";
import renderTools from "@/views/menu/renderTools";
import disableContrast from "./disableContrast";
import selectButtons from "./selectButtons";

export default function disableProfile(profile: string, $menu: HTMLElement) {
  const profileConfig = PROFILES[profile];
  disableContrast();
  userSettings.states.contrast = false;
  profileConfig.tools.forEach((tool: string) => {
    userSettings.states[tool] = false;
    saveUserSettings();
  });
  renderTools();
  selectButtons($menu);
}